import React from 'react';

const DeepDriveCard = ({ item, onStart, onViewReport }) => {
    if (!item) return null;

    const handleButtonClick = () => {
        if (item.IsReportCompleted) {
            if (item.IsReportInProgress) return;
            onViewReport && onViewReport(item);
        } else {
            onStart && onStart(item);
        }
    };

    return (
        <div className="athlete-section row">
            <div className="col-12 col-md-6 content-col">
                <div className="content-wrapper">
                    <h2 className="main-title">Deep Drive</h2>
                    <h3 className="sub-title">{item.Title}</h3>
                    <p className="description">
                        {item.Description}
                    </p>
                    <div className="features-list">
                        {item.Features && item.Features.map(feature => (
                            <div className="feature-item" key={feature.Id}>
                                <span className="check-icon">✓</span>
                                <span>{feature.FeatureTitle}</span>
                            </div>
                        ))}
                    </div>
                    <button
                        className={`start-btn ${item.IsReportCompleted && item.IsReportInProgress ? 'in-progress' : ''}`}
                        onClick={handleButtonClick}
                        disabled={item.IsReportCompleted && item.IsReportInProgress}
                    >
                        {item.IsReportCompleted
                            ? (item.IsReportInProgress ? 'Report In Progress' : 'View Report')
                            : 'Start'
                        }
                    </button>
                </div>
            </div>
            <div className="col-12 col-md-6 image-col">
                <img src={item.MediaUrl} alt={item.Title} className="golfer-image" />
            </div>
        </div>
    );
};

export default DeepDriveCard;
